module.exports = __webpack_public_path__ + "media/images/lp/bg-indique-c9394c84aad0e43128884bc2060b676e.png";